module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-pop@3x-360605043c0d86819c372498e55bf950.png";